<template>
  <step-container heading="Lead Statuses">
    <template v-slot:description>
      <p>In Forefront we organize leads into statuses that you are free to create so that they match your workflow.
        These statuses are further organized into one of size states that we define and use to give you the right user
        interface for how you will want to work the leads.</p>

      <p>Below are the default statues that we think are the best ones to start out with. Feel free to decline any of
        the ones below and to add some of your own.</p>

      <p>You're always able to tweak these statuses in the settings as things change or you fine tune your process in
        Forefront. You'll also be able to add Status Automations so you can automate some of your process and be more
        efficient.</p>
    </template>

    <step-list-section
      heading="Contact Not Made"
      description="This is where the leads you are still trying to make initial contact with will reside."
    >
      <step-item-status
        v-for="status in contactingStatuses"
        :key="status.name"
        :status="status"
      />
    </step-list-section>

    <step-list-section
      heading="Active"
      description="This is where the leads you are currently working on will reside."
    >
      <step-item-status
        v-for="status in activeStatuses"
        :key="status.name"
        :status="status"
      />
    </step-list-section>

    <step-list-section
      heading="Follow Up"
      description="This is where the leads you are following up will reside."
    >
      <step-item-status
        v-for="status in followUpStatuses"
        :key="status.name"
        :status="status"
      />
    </step-list-section>

    <step-list-section
      heading="Completed"
      description="This is where the deals that you have completed will reside."
    >
      <step-item-status
        v-for="status in completedStatuses"
        :key="status.name"
        :status="status"
      />
    </step-list-section>

    <step-list-section
      heading="Dead"
      description="This is where the leads you are no longer pursuing reside."
    >
      <step-item-status
        v-for="status in deadStatuses"
        :key="status.name"
        :status="status"
      />
    </step-list-section>

    <step-list-section
      heading="Non Lead"
      description="This is where the leads created by spam calls or website submissions will reside. If you'd like to see these reporting in the stats and reports sections of Forefront, keep them here. If you have test leads you don't want to show up in the stats, delete them."
    >
      <step-item-status
        v-for="status in nonLeadStatuses"
        :key="status.name"
        :status="status"
      />
    </step-list-section>
  </step-container>
</template>

<script>
import {defineComponent} from 'vue'
import StepContainer from "../component/StepContainer.vue";
import {ENUMS} from "../../../services/enums";
import StepListSection from "../component/StepListSection.vue";
import StepItemStatus from "../component/StepItemStatus.vue";

export default defineComponent({
  name: "OnboardingStepLeadStatus",
  components: {StepItemStatus, StepListSection, StepContainer},
  computed: {
    statuses() {
      return this.$store.state.onboarding.provisionData.statuses;
    },
    contactingStatuses() {
      return this.statuses[ENUMS.StatusStateEnum.Contacting.key]
    },
    activeStatuses() {
      return this.statuses[ENUMS.StatusStateEnum.Active.key]
    },
    followUpStatuses() {
      return this.statuses[ENUMS.StatusStateEnum.FollowUp.key]
    },
    completedStatuses() {
      return this.statuses[ENUMS.StatusStateEnum.Completed.key]
    },
    deadStatuses() {
      return this.statuses[ENUMS.StatusStateEnum.Dead.key]
    },
    nonLeadStatuses() {
      return this.statuses[ENUMS.StatusStateEnum.NonLead.key]
    },
  },
})
</script>

<style scoped lang="scss">

</style>
